"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineAudiDynamicFootnoteService = void 0;
const sonic_feature_hub_tools_1 = require("@oneaudi/sonic-feature-hub-tools");
const dynamic_footnote_service_v1_1 = require("./v1/dynamic-footnote-service-v1");
const definition = {
    id: 'audi-dynamic-footnote-service',
    versions: {
        '1.0.0': dynamic_footnote_service_v1_1.DynamicFootnoteServiceV1Implementation,
    },
    dependencies: {
        featureServices: {
            'audi-market-context-service': '1.0.0',
            'dbad:audi-i18n-service': '1.0.0',
            'dbad:audi-vue-formatter-service': '1.0.0',
            'locale-service': '1.0.0',
            'audi-footnote-service': '1.0.0',
        },
    },
};
const defineAudiDynamicFootnoteService = (0, sonic_feature_hub_tools_1.defineFeatureService)(definition);
exports.defineAudiDynamicFootnoteService = defineAudiDynamicFootnoteService;
//# sourceMappingURL=dynamic-footnote-service.js.map